{
	"tradeSideToggle": {
		"buy": "Купить",
		"sell": "Продать"
	}
}
